/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ContactPageRequestDto } from '../models/contact-page-request-dto';
import { ContactPageResponseDto } from '../models/contact-page-response-dto';
import { StatisticsDto } from '../models/statistics-dto';

@Injectable({
  providedIn: 'root',
})
export class ContactService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findContacts
   */
  static readonly FindContactsPath = '/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContacts$Response(params?: {
    body?: ContactPageRequestDto
  }): Observable<StrictHttpResponse<ContactPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.FindContactsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactPageResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findContacts(params?: {
    body?: ContactPageRequestDto
  }): Observable<ContactPageResponseDto> {

    return this.findContacts$Response(params).pipe(
      map((r: StrictHttpResponse<ContactPageResponseDto>) => r.body as ContactPageResponseDto)
    );
  }

  /**
   * Path part for operation getContactsStatistics
   */
  static readonly GetContactsStatisticsPath = '/contacts/{companyId}/statistics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactsStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactsStatistics$Response(params: {
    companyId: string;
    facetSize?: number;
  }): Observable<StrictHttpResponse<StatisticsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ContactService.GetContactsStatisticsPath, 'get');
    if (params) {
      rb.path('companyId', params.companyId, {});
      rb.query('facetSize', params.facetSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StatisticsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getContactsStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactsStatistics(params: {
    companyId: string;
    facetSize?: number;
  }): Observable<StatisticsDto> {

    return this.getContactsStatistics$Response(params).pipe(
      map((r: StrictHttpResponse<StatisticsDto>) => r.body as StatisticsDto)
    );
  }

}
